import { FormatExtension } from '../types/extensions';
import { FormatList } from '../types/utils';

const isArray = Array.isArray;
const keyList = Object.keys;
const hasProp = Object.prototype.hasOwnProperty;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deepEqual(a: any, b: any, ignoreAttributes?: Array<string>) {
    const ignoreAttributesArr = ignoreAttributes?.map((attribute) => attribute.split('.'));

    if (a === b) return true;

    if (a && b && typeof a == 'object' && typeof b == 'object') {
        const arrA = isArray(a);
        const arrB = isArray(b);
        let i: number;
        let length: number;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let key: any;

        if (arrA && arrB) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            length = (a as Array<any>).length;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if (length !== (b as Array<any>).length) return false;
            for (i = length; i-- !== 0; ) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!deepEqual((a as Array<any>)[i], (b as Array<any>)[i], ignoreAttributes)) return false;
            }
            return true;
        }

        if (arrA !== arrB) return false;

        const dateA = a instanceof Date;
        const dateB = b instanceof Date;
        if (dateA !== dateB) return false;
        if (dateA && dateB) return (a as Date).getTime() === (b as Date).getTime();

        const regexpA = a instanceof RegExp;
        const regexpB = b instanceof RegExp;
        if (regexpA !== regexpB) return false;
        if (regexpA && regexpB) return a.toString() === b.toString();

        const keys = keyList(a).filter(
            (aKey) => !ignoreAttributesArr?.some((attribute) => attribute.length === 1 && attribute[0] === aKey),
        );
        length = keys.length;

        if (
            length !==
            keyList(b).filter(
                (aKey) => !ignoreAttributesArr?.some((attribute) => attribute.length === 1 && attribute[0] === aKey),
            ).length
        ) {
            return false;
        }

        for (i = length; i-- !== 0; ) {
            if (!hasProp.call(b, keys[i])) return false;
        }
        // end fast-deep-equal

        // Custom handling for React
        for (i = length; i-- !== 0; ) {
            key = keys[i];
            if (key === '_owner' && a.$$typeof) {
                // React-specific: avoid traversing React elements' _owner.
                //  _owner contains circular references
                // and is not needed when comparing the actual elements (and not their owners)
                // .$$typeof and ._store on just reasonable markers of a react element
                continue;
            } else {
                // all other properties should be traversed as usual
                if (
                    !deepEqual(
                        (a as Record<typeof key, object>)[key],
                        (b as Record<typeof key, object>)[key],
                        ignoreAttributesArr
                            ?.filter((attribute) => attribute.length > 1 && attribute[0] === key)
                            .map((attribute) => attribute.splice(1).join('.')),
                    )
                ) {
                    return false;
                }
            }
        }

        // fast-deep-equal index.js 2.0.1
        return true;
    }

    // eslint-disable-next-line no-self-compare
    return a !== a && b !== b;
}

/**
 * Remplace la valeur de propriétés par leur typeof, sur toute la profondeur de l'objet.
 * Valorisation avec le typeof pour conserver la vérification du type dans le cas d'une comparaison d'objets.
 * Avantages :
 *    - gère l'ensemble de la profondeur de l'objet
 *    - peut être intégré à un test toMatchObject qui permet une meilleure
 *      lisibilité des erreurs potentielles ({@see validatePhpUnitSnapshot})
 * @param obj objet à modifier
 * @param replacedProperties propriétés à remplacer
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function replacePropertiesWithTypes(obj: any, replacedProperties: string[]): any {
    if (Array.isArray(obj)) {
        return obj.map((i) => replacePropertiesWithTypes(i, replacedProperties));
    } else if (typeof obj === 'object' && obj !== null) {
        let res = {};
        Object.keys(obj).forEach((k) => {
            res = {
                ...res,
                [k]:
                    k && replacedProperties.includes(k)
                        ? typeof obj[k]
                        : replacePropertiesWithTypes(obj[k], replacedProperties),
            };
        });
        return res;
    } else {
        return obj;
    }
}

export const combineFormat = (format: FormatList, extendFormat: FormatExtension | undefined) => {
    if (Array.isArray(extendFormat) && extendFormat.length) {
        return [format, ...extendFormat].join(',');
    }

    return format;
};
